
















































import {Component, Vue} from 'vue-property-decorator'
import ServiceMesh from '../lib/serviceMesh'
import {Getter, State} from 'vuex-class'
import Utils from '@/utils'
import {BookingState} from '@/store/modules/booking'

import Icon from '@/components/proxy/Icon.vue'
import DateHelper from '@/lib/DateHelper'
import moment from 'moment'
import Sheet from '@/components/proxy/Sheet.vue'
import IsLogged from '@/components/IsLogged.vue'
import Btn from '@/components/proxy/Btn.vue'
import {ProfileState} from '@/store/modules/profile'
import {BookingMesh, BookingMode, ReservationResponse, VehicleType} from '@/lib/kepler/interfaces'
import {
  VList,
  VListTile,
  VListTileAction,
  VListTileActionText,
  VListTileContent,
  VListTileSubTitle,
  VListTileTitle,
} from 'vuetify/lib'

@Component({
  components: {
    Btn,
    IsLogged,
    Sheet,
    Icon,
    ActiveReservationCard: Utils.loadComponent('entities/reservation/ActiveReservationCard'),
    LoopingBG: Utils.loadComponent('LoopingBG'),
    Layout: Utils.loadComponent('proxy/Layout'),
    GradientCard: Utils.loadComponent('GradientCard'),
    Container: Utils.loadComponent('proxy/Container'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
    Avatar: Utils.loadComponent('proxy/Avatar'),

    VListTileAction, VListTileActionText,
    VListTileContent, VListTileSubTitle,
    VListTileTitle,
    VListTile,
    VList,
  },
})

export default class CorporateActivities extends Vue {
  @State((state) => state.booking) public bookingState!: BookingState
  @State((state) => state.profile) public profileState!: ProfileState
  @State((state) => state.booking.fakeTerminatedReservations) public markedReservations!: number[]
  @Getter('activeReservations') public currents!: ReservationResponse[]

  protected get crtMesh() {
    return this.bookingState.meshes.find((m) => {
      return m.booking_mode === 'RT'
    })
  }

  protected get futures() {
    return this.bookingState.futureReservations.filter((res) => {
      const start = res.start_timestamp
      if (start) {
        return start > DateHelper.getTimestamp()
      }
    })
  }

  protected get nextMission() {
    const startArr = this.futures.map((res) => {
      return res.start_timestamp || Infinity
    })
    const nextMissionDate = moment.unix(Math.min(...startArr))
    return nextMissionDate.isValid() ? moment().to(nextMissionDate) : ''
  }

  protected action(mesh: ServiceMesh | BookingMesh) {
    const type = mesh.vehicle_type.toLowerCase()
    const mode = mesh.booking_mode.toLowerCase()
    return this.$router.push({name: 'book', params: {type, mode}})
  }

  protected color(vehicleType: string) {
    return {backgroundColor: ServiceMesh.colors[vehicleType]}
  }

  protected icon(bookingMode: BookingMode, vehicleType: VehicleType) {
    const serviceMesh: ServiceMesh = new ServiceMesh()
    return serviceMesh.getImage(bookingMode, vehicleType, 'OK')

  }

  protected text(mesh: ServiceMesh) {
    const key = `activities.booking.${mesh.vehicle_type}.${mesh.booking_mode}`.toLowerCase()
    return {
      action: this.$t(`${key}.action`),
      description: this.$isAvailable(`${key}.description`),
    }
  }

}
